import getProp from '@f/get-prop'

export const getIntegrationsByWorkspaceSlug = (state, workspaceSlug) =>
  getProp(`integrationsByWorkspaceSlug.${workspaceSlug}`, state) || {}

export const getIntegrationsByWorkspaceSlugAndSourceId = (state, workspaceSlug, sourceId) => {
  const integrations = getIntegrationsByWorkspaceSlug(state, workspaceSlug).data || []

  return integrations.filter(({ project }) => {
    return project === sourceId
  })
}



// WEBPACK FOOTER //
// ./selectors/integrations.js